import { Grid, GridProps } from "@chakra-ui/react";

import CardMotion, { GridItemType } from "../Card/CardMotion";

type GridLayoutProps = {
  templateAreas: GridProps["templateAreas"];
  templateRows?: GridProps["gridTemplateRows"];
  templateColumns?: GridProps["gridTemplateColumns"];
  items: Array<GridItemType>;
  isZoomIn?: boolean;
};

export const GridLayout = ({
  templateAreas,
  templateRows = {
    base: "none",
    md: "1fr repeat(4, 240px)",
  },
  templateColumns = {
    base: "none",
    md: "repeat(6, 1fr)",
  },
  isZoomIn,
  items,
}: GridLayoutProps) => (
  <Grid
    display={{ base: "flex", md: "grid" }}
    flexDirection={{ base: "column", md: "unset" }}
    templateAreas={templateAreas}
    gridTemplateRows={templateRows}
    gridTemplateColumns={templateColumns}
    gap="20px"
    p={0}
    color="blackAlpha.700"
    fontWeight="bold"
  >
    {items.map(
      (
        {
          content,
          gridItemSetting = { h: { base: "200px", md: "100%" } },
          isGalerryIcon,
          filterBrightnessPercent,
        },
        index,
      ) => (
        <CardMotion
          key={index}
          isZoomIn={isZoomIn}
          isGalerryIcon={isGalerryIcon}
          content={content}
          gridItemSetting={gridItemSetting}
          filterBrightnessPercent={filterBrightnessPercent}
        />
      ),
    )}
  </Grid>
);
